import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/main-component/App/App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './sass/style.scss';
import './css/mobile-about-spacing.css';
import './css/mobile-navbar-overlay.css';

import { store } from "./store/index";
import { Provider } from "react-redux";
import { onFirstInteraction } from './utils/firstInteraction';

// Icon fonts are not needed for first paint; load them after interaction or a short idle delay.
const loadIconCss = () => {
    import('./css/font-awesome.min.css');
    import('./css/themify-icons.css');
    import('./css/flaticon.css');
};
onFirstInteraction(loadIconCss);
window.addEventListener('load', () => {
    window.setTimeout(loadIconCss, 2500);
});

// The persisted store rehydrates on its own; rendering is not blocked on it.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

reportWebVitals();
